export default __webpack_public_path__ + "static/media/Rectangle 1052.2467b215.png";